import classNames from 'classnames/bind';
import React from 'react';
import { NavLink } from 'react-router-dom';
import useGetNavigationItems from '../../../hooks/navigation/useGetNavigationItems';
import { ItemType } from '../../../models/Navigation';
import NavigationDropdown from './NavigationDropdown';
import styles from './Navigation.module.scss';
import useFetchUserProfile from '../../../hooks/profile/useFetchUserProfile';
import useFetchUserPermissions from '../../../hooks/permissions/useFetchUserPermissions';

const cx = classNames.bind(styles);

const renderLink = (item) =>
  item.isExternal ? (
    <a
      key={item.text}
      className={cx('link', { active: item.isActive })}
      href={item.to}
      target="_blank"
      rel="noreferrer"
    >
      <span>{item.text}</span>
    </a>
  ) : (
    <NavLink
      key={item.text}
      className={cx('link', { active: item.isActive })}
      to={item.to}
      data-testid={item.dataTestId}
    >
      <span>{item.text}</span>
    </NavLink>
  );

const Navigation = (): React.ReactElement => {
  const { visibleItems, hiddenItems } = useGetNavigationItems();
  const { data: profile } = useFetchUserProfile();
  const { data: userPermissions } = useFetchUserPermissions();

  return (
    <nav
      className={cx('body', { disabled: !profile?.active || !userPermissions })}
      data-no-translate={1}
      data-testid="nav"
    >
      <div className={cx('list')}>
        {visibleItems.map((item) =>
          item.type === ItemType.DROPDOWN ? (
            <NavigationDropdown
              key={item.text}
              isActive={item.isActive}
              options={item.options}
              text={item.text}
              dataTestId={item.dataTestId}
            />
          ) : (
            renderLink(item)
          )
        )}
        {hiddenItems.length > 0 && (
          <NavigationDropdown options={hiddenItems} text="More" isNestedLeftAligned dataTestId="more-link" />
        )}
      </div>
    </nav>
  );
};

export default Navigation;
